<div class="bg-image" [ngStyle]="{'background-image': !isImpressionAvailable ? 'url(' + sensitiveImage + ')' : ''}"
  [ngClass]="{'impressionClass': isImpressionAvailable}"></div>
<div class="sensitive-msg">
  <img (click)="stopPropagation($event)" src="../../../../../assets/images/sensitive.png">
  <div class="sensitive-data-txt " (click)="stopPropagation($event)"> {{ 'CP_SM_SENSITIVE_IMG_LBL' | customTranslation:
    translationData}}</div>
  <span class="link" (click)="onClick($event)" (click)="stopPropagation($event)">{{ 'CP_SM_SENSITIVE_SEE_PHOTO' |
    customTranslation: translationData}}</span>
</div>
